import {
  Controller,
  useFormContext,
  FieldValues,
  Path,
  get
} from 'react-hook-form';
import { Textarea, TextareaProps } from '../textarea';

type RHFTextareaProps<T extends FieldValues> = {
  name: Path<T>;
} & Omit<TextareaProps, 'name' | 'value' | 'error'>;

export function RHFTextarea<T extends FieldValues>({
  name,
  ...props
}: RHFTextareaProps<T>) {
  const {
    control,
    formState: { errors }
  } = useFormContext<T>();

  const fieldError = get(errors, name);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Textarea
          error={!!fieldError}
          helperText={fieldError?.message || props.helperText}
          {...field}
          {...props}
        />
      )}
    />
  );
}
